import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class PrObjectiveFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};

    let goals = [];
    if (entity && entity.investmentGoals)
      entity.investmentGoals.map(g => goals.push(g));

    return this.formBuilder.group(
      {
        accountId: [entity ? entity.accountId : null, Validators.required],
        liquidity: [entity ? entity.liquidity : null],
        monthlySaving: [entity ? entity.monthlySaving : null],
        epargnePrecaution: [entity ? entity.epargnePrecaution : null],
        investmentGoals: [goals],
        /*,
      companyName: [entity? entity.companyName : null],
      situation: [entity? entity.situation : null],
      groupe: [entity? entity.groupe : null],
      categorie: [entity? entity.categorie : null],
      estimatedEvolution: [entity? entity.estimatedEvolution : null],
      */
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      liquidity: this.emptyIsNull(this.form.value.liquidity),
      monthlySaving: this.emptyIsNull(this.form.value.monthlySaving),
      epargnePrecaution: this.emptyIsNull(this.form.value.epargnePrecaution),
      investmentGoals: this.emptyIsNull(this.form.value.investmentGoals),
      /*,
      estimatedEvolution: this.emptyIsNull(this.form.value.estimatedEvolution),
      groupe: this.emptyIsNull(this.form.value.groupe),
      label: this.emptyIsNull(this.form.value.label),
      situation: this.emptyIsNull(this.form.value.situation),
      userId: this.form.value.userId
      */
    };
    return dto;
  }
}
